import { IsOptional, IsString, IsUUID } from 'class-validator'
import { ApiPropertyOptional } from '@nestjs/swagger'

export class UpdateSchoolGroupDto {
  @ApiPropertyOptional({
    description: "ID de l'établissement",
    type: 'string',
  })
  @IsOptional()
  @IsString()
  establishmentId?: string

  @ApiPropertyOptional({
    description: 'Nom du groupe',
    type: 'string',
  })
  @IsOptional()
  @IsString()
  name?: string

  @ApiPropertyOptional({
    description: 'Description du groupe',
    type: 'string',
  })
  @IsOptional()
  @IsString()
  description?: string

  @ApiPropertyOptional({
    description: 'ID du type de groupe',
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  typeId?: string

  @ApiPropertyOptional({
    description: "ID de l'année scolaire",
    type: 'string',
  })
  @IsOptional()
  @IsUUID('4')
  schoolYearId?: string
}
